import { ChecklistConfigSection } from '@/common/types/checklist.def.ts'
import { stringArrayToSelectOptions } from '@/utils/misc.ts'

export type GetChecklistByIdRequest = {
  checklistId: number
}

export type GetAllChecklistsRequest = {
  checklistType?: string
  country?: string
  isComplete?: boolean
}

export type UpdateChecklistItemRequest = {
  checklistId: number,
  groupName: string,
  order: number
  newCheckValue: boolean | null
  disabled: boolean | null
}

export type AddChecklistRequest = {
  checklistConfigId: number
  employeeName: string
  country: string
  // Access is entity-scoped: the server gates AddChecklist on this entity, and an empty value is
  // denied. Country is retained as domain data.
  employmentEntity: string
  employeeId?: string
  lineManagerEmployeeId?: string
  joinDate?: string
  verbalOfferAcceptanceDate?: string
  terminationDate?: string
  resignationDate?: string
  lastWorkingDay?: string
}

export type EditChecklistRequest = {
  checklistId: number
  lineManagerEmployeeId?: string
  joinDate?: string
  verbalOfferAcceptanceDate?: string
  terminationDate?: string
  resignationDate?: string
  lastWorkingDay?: string
}

export type RemoveChecklistsRequest = {
  checklistIds: number[]
}

export type DownloadChecklistDataRequest = {
  categories: string[]
  targets: string[]
}

export type AddChecklistConfigRequest = {
  name: string
  category: string
  target: string
  customFieldNames: string[]
  sections: ChecklistConfigSection[]
}

export type UpdateChecklistConfigRequest = AddChecklistConfigRequest & {
  id: number
}

export type GetChecklistConfigRequest = {
  id: number
}

export type DeleteChecklistConfigRequest = {
  id: number
}

export const ChecklistRefDateType = {
  // ProceedDate: 'Proceed Date',
  VerbalOfferAcceptanceDate: 'Verbal Offer Acceptance Date',
  TerminationDate: 'Termination Date',
  ResignationDate: 'Resignation Date',
  NoticeDate: 'Notice Date',
  lastWorkingDay: 'Last Working Day',
}
export const ChecklistRefDateTypeOptions = stringArrayToSelectOptions(Object.values(ChecklistRefDateType))

export const ChecklistCustomField = {
  EmployeeId: 'Employee ID',
  LineManagerEmployeeId: 'Line Manager Employee ID',
  JoinDate: 'Join Date',
  // ProceedDate: 'Proceed Date',
  VerbalOfferAcceptanceDate: 'Verbal Offer Acceptance Date',
  TerminationDate: 'Termination Date',
  ResignationDate: 'Resignation Date',
  NoticeDate: 'Notice Date',
  LastWorkingDay: 'Last Working Day',
}
export const ChecklistCustomFieldOptions = stringArrayToSelectOptions(Object.values(ChecklistCustomField))

export type ChecklistCustomFieldType = 'text' | 'date' | 'employeeSearch' | 'countrySelect'

export const ChecklistCustomFieldMapping: Record<string, { name: string, type: ChecklistCustomFieldType }> = {
  [ChecklistCustomField.JoinDate]: { name: 'joinDate', type: 'date' },
  [ChecklistCustomField.EmployeeId]: { name: 'employeeId', type: 'employeeSearch' },
  [ChecklistCustomField.LineManagerEmployeeId]: { name: 'lineManagerEmployeeId', type: 'employeeSearch' },
  // [ChecklistCustomField.ProceedDate]: { name: 'proceedDate', type: 'date' },
  [ChecklistCustomField.VerbalOfferAcceptanceDate]: { name: 'verbalOfferAcceptanceDate', type: 'date' },
  [ChecklistCustomField.TerminationDate]: { name: 'terminationDate', type: 'date' },
  [ChecklistCustomField.ResignationDate]: { name: 'resignationDate', type: 'date' },
  [ChecklistCustomField.NoticeDate]: { name: 'noticeDate', type: 'date' },
  [ChecklistCustomField.LastWorkingDay]: { name: 'lastWorkingDay', type: 'date' },
}

export const ChecklistRefDateOptions = Object.entries(ChecklistCustomFieldMapping)
.filter(([, config]) => config.type === 'date')
.map(([label]) => {
  return {
    label,
    value: label,
  }
})
